const searchHelperText = {
	general: "Search by PO / Invoice# / Sku / SSCC",
	transfer: "Search by PO / Invoice / Transfer / SSCC Label",
	asnGeneral: "Search by PO / SSCC Label",
	asnTransfer: "Search by PO / Transfer / SSCC Label",
	productLabel: "Scan or enter sku or barcode",
	creditRequest: "Search by PO / Credit Request number"
};
const buttonMessage = "Search";

const manualReceiveMessage = {
	EDI: "There are additional items for this purchase order that still awaiting an EDI from the supplier. You can however, scan the items belonging to this invoice and we will match them off against the EDI file when it arrives from the supplier.",
	EDILAM:
		"This purchase order is still awaiting an EDI from the supplier. You can however, scan the items belonging to this invoice and we'll match it to the EDI when it is made available by the supplier.",
	manual: "This purchase order has no EDI from the supplier. You can however, still scan the items.",
};

export { searchHelperText, buttonMessage, manualReceiveMessage };
